import axios from "axios";
import { ReferenceTable } from "../../types/interfaces/admin/ReferenceResponse";
import { SessionStore } from "../../types/store";
import { getReferenceRoute, newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/reference-values`;

export const getReferenceTable = async (
  tables: ReferenceTable[],
  schema: string,
  table: string,
  includeDisabled: boolean = false,
) => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );
  const route = getReferenceRoute(tables, schema, table);

  const url = `${BASE_URL}/${route}${includeDisabled ? "?disabled=true" : ""}`;

  const res = await axios.get(url, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
